// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Rooh","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1ksab","obliqueLine":"membershipbadge_obliqueLine__3ww7q"};